export const CLEAR_CREDENTIALS = 'Auth/CLEAR_CREDENTIALS';
export const CLEAR_INVITATION_DATA = 'Auth/CLEAR_INVITATION_DATA';

export const EMPTY_AUTH = 'Auth/EMPTY_AUTH';

export const FETCH_LOGGED_IN_USER = 'Auth/FETCH_LOGGED_IN_USER';
export const FETCH_LOGGED_IN_USER_SUCCESS = 'Auth/FETCH_LOGGED_IN_USER_SUCCESS';
export const FETCH_LOGGED_IN_USER_FAILURE = 'Auth/FETCH_LOGGED_IN_USER_FAILURE';

export const FETCH_LOGIN = 'Auth/FETCH_LOGIN';
export const FETCH_LOGIN_SUCCESS = 'Auth/FETCH_LOGIN_SUCCESS';
export const FETCH_LOGIN_FAILURE = 'Auth/FETCH_LOGIN_FAILURE';

export const FETCH_REQUEST_INVITATION = 'Auth/FETCH_REQUEST_INVITATION';
export const FETCH_REQUEST_INVITATION_SUCCESS = 'Auth/FETCH_REQUEST_INVITATION_SUCCESS';
export const FETCH_REQUEST_INVITATION_FAILURE = 'Auth/FETCH_REQUEST_INVITATION_FAILURE';

export const FETCH_RESET_PASSWORD = 'Auth/FETCH_RESET_PASSWORD';
export const FETCH_RESET_PASSWORD_SUCCESS = 'Auth/FETCH_RESET_PASSWORD_SUCCESS';
export const FETCH_RESET_PASSWORD_FAILURE = 'Auth/FETCH_RESET_PASSWORD_FAILURE';

export const FETCH_SIGNUP = 'Auth/FETCH_SIGNUP';
export const FETCH_SIGNUP_SUCCESS = 'Auth/FETCH_SIGNUP_SUCCESS';
export const FETCH_SIGNUP_FAILURE = 'Auth/FETCH_SIGNUP_FAILURE';

export const SEND_FORGOT_PASSWORD_EMAIL = 'Auth/SEND_FORGOT_PASSWORD_EMAIL';
export const SEND_FORGOT_PASSWORD_EMAIL_SUCCESS = 'Auth/SEND_FORGOT_PASSWORD_EMAIL_SUCCESS';
export const SEND_FORGOT_PASSWORD_EMAIL_FAILURE = 'Auth/SEND_FORGOT_PASSWORD_EMAIL_FAILURE';

export const SET_CREDENTIALS = 'Auth/SET_CREDENTIALS';
export const SET_INVITATION_DATA = 'Auth/SET_INVITATION_DATA';
export const SET_TOKEN = 'Auth/SET_TOKEN';
export const SET_USER = 'Auth/SET_USER';
export const UPDATE_AUTH = 'Auth/UPDATE_AUTH';



// WEBPACK FOOTER //
// ./src/containers/Auth/store/constants.js